var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.54 9C10.6 9.89 10.75 10.76 10.99 11.59L9.79 12.79C9.38 11.59 9.12 10.32 9.03 9H10.54ZM20.4 21.02C21.25 21.26 22.12 21.41 23 21.47V22.96C21.68 22.87 20.41 22.61 19.2 22.21L20.4 21.02ZM11.5 7H8C7.45 7 7 7.45 7 8C7 17.39 14.61 25 24 25C24.55 25 25 24.55 25 24V20.51C25 19.96 24.55 19.51 24 19.51C22.76 19.51 21.55 19.31 20.43 18.94C20.33 18.9 20.22 18.89 20.12 18.89C19.86 18.89 19.61 18.99 19.41 19.18L17.21 21.38C14.38 19.93 12.06 17.62 10.62 14.79L12.82 12.59C13.1 12.31 13.18 11.92 13.07 11.57C12.7 10.45 12.5 9.25 12.5 8C12.5 7.45 12.05 7 11.5 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7fc2dad90f66b3d5afd19fa0845c540e.svg";
export { ForwardRef as ReactComponent };